// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimsList-cls1_bC2","cls2":"ClaimsList-cls2_Heg ClaimsList-cls1_bC2"};